import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultChecklistData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'checklist-columns',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'checklist-layout',
              type: 'TwoColumnLayout',
              props: {
                leftWidth: '50%',
                rightWidth: '50%',
                columnGap: 5,
                showDivider: true,
              },
              children: {
                leftColumn: [
                  {
                    id: 'section-marriage',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Marriage or divorce',
                      description:
                        '- Update beneficiary designations (retirement accounts, insurance, POD/TOD accounts)\n- Revise will and trust(s) to reflect new spouse or remove ex-spouse\n- Update powers of attorney and healthcare directives',
                      iconType: 'calendar',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'section-birth',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Birth or adoption of a child',
                      description:
                        '- Add guardianship provisions to will\n- Create or update trust(s) for minors\n- Review life insurance coverage',
                      iconType: 'calendar',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'section-incapacity',
                    type: 'PresentationListItem',
                    props: {
                      title:
                        'Incapacity or death of a beneficiary or fiduciary',
                      description:
                        '- Replace unavailable, incapacitated, or deceased executors, trustees, or guardians\n- Adjust distribution provisions for remaining beneficiaries',
                      iconType: 'calendar',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'section-wealth',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Significant change in wealth',
                      description:
                        '- If assets increase, review estate tax exposure and gifting strategies\n- If assets decrease, simplify your plan or reduce unnecessary structures',
                      iconType: 'calendar',
                      iconColor: 'PRIMARY',
                    },
                  },
                ],
                rightColumn: [
                  {
                    id: 'section-business',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Business formation, sale or closure',
                      description:
                        '- Update ownership records in estate plan\n- Adjust succession planning documents\n- Review buy-sell agreements',
                      iconType: 'calendar',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'section-relocation',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Relocation to a new state or country',
                      description:
                        "- Review plan for compliance with new jurisdiction's laws\n- Update healthcare and financial directives to meet local requirements",
                      iconType: 'calendar',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'section-laws',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Changes in laws or tax regulation',
                      description:
                        '- Adjust plan to align with changing exemptions and minimize exposure to new taxes',
                      iconType: 'calendar',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'section-retirement',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Retirement',
                      description:
                        '- Revisit income needs and distribution strategies\n- Adjust beneficiary designations for retirement accounts',
                      iconType: 'calendar',
                      iconColor: 'PRIMARY',
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  };
}
